exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".builder-container[data-v-3f1e2143] {\n  display: grid;\n  gap: 10px 10px;\n  grid-template-columns: 1fr;\n}\n[data-v-3f1e2143] .builder-bottom-right {\n  margin-top: 20px;\n  grid-column-end: -1;\n  justify-self: end;\n  align-self: end;\n}\n", ""]);

